const endpoint = process.env.REACT_APP_ENDPOINT
  ? process.env.REACT_APP_ENDPOINT
  : "";
export const URL = 'https://www.crafterspro.net/cricut/api';
//export const URL = 'http://localhost/cricut/api';